const en = {
  'home-welcome': 'Welcome, click to log in and start exploring the app',
  'home-login-button': 'LogIn',
  'home-section-1-title': "Share notes with everyone!",
  'home-section-1-p': "Bilhetinhos is a minimalistic social network that allows You to interact with the ones You care about!",
  'home-section-2-title': "Warning!",
  'home-section-2-p': "This website is under construction and may suffer several changes or data lost.",
  'footer-by': 'Developed by ',
  'fab-actions': 'Actions',
  'fab-new-note': 'Create note',
  'fab-new-mate': 'Add mate',
  'fab-scroll-to-top': 'Scroll to top',
  'navbar-btn-noteboard': 'My board',
  'navbar-btn-mates': 'Mates',
  'navbar-usermenu-default-label': 'User menu',
  'navbar-notifications-default-label': 'Notifications',
  'notifications-default-label': 'Everything is up to date!',
  'notifications-clear-all': 'Clear all notifications',
  'user-menu-btn-profile': 'Profile',
  'user-menu-btn-settings': 'Settings',
  'user-menu-signout': 'Sign Out',
  'warning-modal-title': 'Are You sure?',
  'warning-modal-subtitle': 'ATTENTION!',
  'warning-modal-btn-yes': 'Yes, go on',
  'warning-modal-btn-cancel': 'Cancel',
  'remove-mate-modal-question': "You're about to remove {mateNameOrEmail}. This action CANNOT be undone. Are you sure you want to proceed?",
  'remove-note-modal-question': "You're about to remove note {noteTitle}. This action CANNOT be undone. Are you sure you want to proceed?",
  'toastr-success-title': 'Success!',
  'toastr-error-title': 'Error!',
  'toastr-attention-title': 'Attention!',
  'toastr-error-trying-load-mates': "An error occured while trying to load one or more mates.",
  'toastr-maintenance-title': 'Server in maintenance!',
  'toastr-maintenance-message': 'It is highly recommended that you do not use this site during maintenance because your data may be compromised. Thank you!',
  'profile-saved': 'Your profile data has been saved.',
  'profile-image-loading-error': 'Cannot load your image',
  'profile-image-updated': 'Your profile picture was successfully updated',
  'profile-cover-image-updated': 'Your cover image was successfully updated',
  'profile-image-error-size-or-type': 'The image file maximum size is 500kb. Only jpg, jpeg and png files are accepted.',
  'profile-header-title': 'Profile',
  'profile-name-placeholder': 'Your full name or nickname',
  'profile-bio-placeholder': 'Biography',
  'profile-phone-placeholder': 'Phone number',
  'profile-btn-save': 'Save',
  'profile-picture-label': 'Profile picture',
  'profile-cover-image-label': 'Cover image',
  'profile-pic-input-placeholder': 'Paste here the URL and press enter',
  'profile-picture-upload-tip': 'or click the image below to make an upload',
  'mates-alert-title': 'Friendship invite',
  'mates-alert-description': 'Click to accept {userEmail} invitation',
  'mates-pending-invite': 'Pending invitation',
  'mates-decline-invitation-title': 'Invitation canceled',
  'mates-decline-invitation-description': 'Mate has declined your friendship solicitation',
  'mates-accept-invitation-title': 'Invitation accepted',
  'mates-accept-invitation-description': 'Mate has accepted your friendship solicitation!',
  'mates-list-header-label': 'Mates',
  'mates-new-mate-email-placeholder': "Inform your mate's E-mail",
  'mates-add-mate': 'Add mate',
  'mates-no-mates-label': "You doesn't have any mates yet",
  'toastr-notification-sent': 'Your notification has been sent',
  'noteboard-header-label': 'Noteboard',
  'noteboard-btn-new-note': 'New Note',
  'noteboard-accordion-my-notes-label': 'My notes',
  'noteboard-accordion-mates-notes-label': "Mates's notes",
  'noteboard-my-notes-no-note': "You haven't written any notes yet",
  'noteboard-mates-notes-no-note': 'Nothing to show here',
  'noteboard-btn-show-as-visitor': 'View as visitor',
  'signout-label': 'Signing out...',
  'spinner-default-label': 'Loading...',
  'api-mates-added-successfully': 'User successfully added to your mates list',
  'api-mates-error-mate-already-added': "E-mail's owner is already your mate",
  'api-mates-error-cannot-add-yourself': "You cannot add yourself as a mate.",
  'api-mates-error-mate-not-found': "The E-mail provided does not match any registered user.",
  'api-notes-error-uid-not-found': "No user found with this uid",
  'api-notes-error-email-not-found': "No user found with this E-mail",
  'editnote-notify-users-title': "A mate has put a note on your board",
  'editnote-notify-users-description': "Click here to see",
  'editnote-published': "Your note has been published!",
  'editnote-error-empty-inputs': "You have to provide a title and a message to publish your note",
  'editnote-accordion-item-notecolor-label': "Note color",
  'editnote-accordion-item-fontcolor-label': "Font color",
  'editnote-accordion-item-fontsize-label': "Font size",
  'editnote-accordion-item-mates-label': "Share note with these mates",
  'editnote-you-have-no-mates': "You have no mates",
  'editnote-notetitle-placeholder': "The note title goes here",
  'editnote-message-placeholder': "Type your message here!",
  'editnote-btn-create': "Publish",
  'editnote-title': "Customize you note",
  'editnote-accordion-item-note-attachments-label': 'Photo album',
  'editnote-attachment-already-added-warning': 'This URL has is already added',
  'editnote-attachment-empty-input-warning': 'You need to inform an URL to add an image',
  'editnote-accordion-item-attachments-picker-label': 'Insert an URL and a description to your image',
  'editnote-add-attachment-url-placeholder': 'Paste the URL here',
  'editnote-add-attachment-description-placeholder': 'Say something about this image',
  'notepreview-created-by': "Created by {owner}",
  'notepreview-attachments-label': "View attachments",
  'userpresentation-contact-info-label': 'Contact Information',
  'userpresentation-email-label': 'E-mail',
  'matenoteboard-notes-no-note': "This user doesn't have any notes",
  'matenoteboard-user-not-allowed': "You don't have permission to see this content",
  'settings-board-privacy-label': 'Change board privacy',
  'settings-board-privacy-select-public': 'Public (visible to anyone)',
  'settings-board-privacy-select-mates': 'Mates (only your mates can see)',
  'settings-board-privacy-select-private': 'Private (only you can see)',
  'attachment-viewer-title': 'Image view',
  'attachment-viewer-filename-label': 'File name',
  'attachment-viewer-date-label': 'Posted at',
  'attachment-viewer-description-label': 'Description',
}

export default en